import { useSearchParams } from "react-router-dom";
import { MedicalFields } from "../../../../enums/MedicalReportEnums";
import { IStepFields } from "../../../../interface/MedicalRecord";
import { RecordValueRenderer } from "../RecordValueRenderer";

export const MedicalRecordStep = ({
  step,
  data,
  isPrintMode,
  isOnlyDetails,
}: any) => {
  const [searchParams] = useSearchParams();
  const stepParam = searchParams.get("step");
  const isSelected = stepParam == step?.Id;

const hasOwnValue = (field: IStepFields): boolean => {
  return (
    field?.IsRepeatable === true ||
    (field?.Value !== null &&
      field?.Value !== undefined &&
      field?.Value !== "") ||
    field?.Selected === true
  );
};

const hasValueOrSelected = (field: IStepFields): boolean => {

  if (
    field.Type === MedicalFields.Paragraph &&
    !field.IsVisible
  ) {
    return false;
  }

  if (hasOwnValue(field)) {
    return true;
  }

  return (
    field?.InverseParentStepFields?.some(
      (child) => hasValueOrSelected(child)
    ) ?? false
  );
};
  const renderFieldWithChildren = (field: IStepFields) => {
  const hasChildrenWithValues =
    field?.InverseParentStepFields?.some(hasValueOrSelected) ||
    (field?.RepeatedGroups?.length ?? 0) > 0;

  if (!hasChildrenWithValues && !hasOwnValue(field)) {
    return null;
  }

  return (
    <div className="mb-4">
      {field.Type === MedicalFields.Paragraph ? (
        <>
          <p className="text-primary-textFont mb-2 font-bold">
            {field?.Name}
          </p>

          <div className="ml-4 space-y-2">
            {field.InverseParentStepFields?.map((childField) => {
              if (!hasValueOrSelected(childField)) {
                return null;
              }

              return (
                <div
                  key={childField.Id}
                  className="flex flex-col gap-1"
                >
                  {renderFieldWithChildren(childField)}
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <RecordValueRenderer field={field} data={data} />
      )}
    </div>
  );
};

 const stepRender = (currentStep: any) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      {currentStep?.StepFields?.map(
        (field: IStepFields, index: number) => {
          const isExist = hasValueOrSelected(field);

          return (
            isExist &&
            !(field.Type === MedicalFields.MultiFile && isPrintMode) && (
              <div
                key={index}
                className={`flex flex-col gap-1 ${
                  currentStep?.StepFields.length === 1 ||
                  field.Type === MedicalFields.TextEditor ||
                  field.Type === MedicalFields.Repeater ||
                  field.Type === MedicalFields.MultiFile ||
                  field.Type === MedicalFields.Date ||
                  field.Type === MedicalFields.SelectWithInputs ||
                  field.Type === MedicalFields.Paragraph
                    ? "col-span-2"
                    : ""
                }`}
              >
                {renderFieldWithChildren(field)}
              </div>
            )
          );
        }
      )}
    </div>
  );
};

  const filteredStepFields = (stepFields: IStepFields[]) => {
    return stepFields.filter(hasValueOrSelected);
  };

  const visibleFields = filteredStepFields(step?.StepFields || []);


  return visibleFields?.length ? (
    <div
      className={`rounded-lg border p-4 ${isSelected
        ? "border-orange !bg-[#FFB0001A]"
        : "border-[#919EAB33] bg-Gray"
        } ${visibleFields?.length > 4 ? "col-span-2" : ""}`}
    >
      {step?.Name && (
        <div className="flex justify-between">
          <h2 className="text-primary-text mb-4 font-semibold">{step?.Name}</h2>
        </div>
      )}
      {stepRender(step)}
      {step?.InverseParentSteps &&
        step?.InverseParentSteps?.length > 0 &&
        step?.InverseParentSteps?.map((subStep: any, i: number) => {
          return (
            subStep?.IsVisible && (
              <div key={i}>
                <h2 className="text-primary-text my-4 font-semibold">
                  {subStep?.Name}
                </h2>
                {stepRender(subStep)}
              </div>
            )
          );
        })}
    </div>
  ) : (
    <></>
  );
};
